export enum IndexingEnum {
  BUTTON_CLEAR_FILTER = 'button-clear-filter',
  CITY_APPOINTMENTS_OPTION_CTA_BUTTON = 'city-appointments-option--cta-button',
  CITY_APPOINTMENTS_OPTION_CTA_TITLE = 'city-appointments-option--cta-title',
  CITY_APPOINTMENTS_OPTION_ITEM = 'city-appointments-option--item',
  CITY_APPOINTMENTS_OPTION_PICTURE = 'city-appointments-option--picture',
  CITY_APPOINTMENTS_OPTION_TITLE = 'city-appointments-option--title',
  CITY_STORY_BUTTON_LEARN_MORE = 'city-story--button-learn-more',
  CITY_STORY_DESCRIPTION = 'city-story--description',
  CITY_STORY_STYLED_VIDEO = 'city-story--styled-video',
  CITY_STORY_TITLE = 'city-story--title',
  CLOSE_MODAL_FILTER_BY_LETTER = 'close-modal--filter-by-letter',
  INDEX_LINK_BY_HEADER_NAME = 'index-link--by-header-name',
  INDEXING_CARD_CITY_NAME = 'indexing-card--city-name',
  INDEXING_CARD_ITEM = 'indexing-card--item',
  INDEXING_CARD_ITEM_NAME = 'indexing-card--item-name',
  INDEXING_CARD_SEE_MORE = 'indexing-card--see-more',
  INDEXING_CARD_SEE_MORE_BUTTON = 'indexing-card--see-more-button',
  INDEXING_CARD_SEE_MORE_LINK = 'indexing-card--see-more-link',
  INDEXING_CARD_TELEHEALTH_URL = 'indexing-card--telehealth-url',
  INDEXING_EXAM_PAGE_TITLE = 'indexing--exam-page-title',
  INDEXING_SPECIALTY_PAGE_TITLE = 'indexing--specialty-page-title',
  PROFESSIONAL_KNOW_MORE_BUTTON = 'know-more-button--professional-profile',
  PROFESSIONAL_LICENSE_HEADER = 'professional-license-header',
  PROFESSIONAL_PROFILE_ASIDE_CARD = 'professional-aside-card',
  PROFESSIONAL_PROFILE_AVATAR = 'professional-avatar-header',
  PROFESSIONAL_PROFILE_AVATAR_DEFAULT = 'professional-avatar-header-default',
  PROFESSIONAL_PROFILE_HEADER = 'professional-profile-header',
  PROFESSIONAL_PROFILE_PROCEDURE_ITEM = 'professional-procedure--item',
  PROFESSIONAL_PROFILE_SCHEDULE_BUTTON = 'schedules-button--professional-profile',
  PROFESSIONAL_PROFILE_SCHEDULE_BUTTON_HEADER = 'schedules-button--professional-profile-header',
  PROFESSIONAL_PROFILE_TAB_ABOUT = 'tab-about--professional-profile',
  PROFESSIONAL_PROFILE_TAB_RATING = 'tab-rating--professional-profile',
  PROFESSIONAL_PROFILE_TABS_CONTAINER = 'tab-container--professional-profile',
  PROFESSIONAL_REDIRECT_MODAL_CLOSE_BUTTON = 'professional-redirect-modal--close-button',
  PROFESSIONAL_REDIRECT_MODAL_CLOSE_LINK_REDIRECT = 'professional-redirect-modal--link-redirect',
  PROFESSIONAL_REDIRECT_MODAL_TEXT = 'professional-redirect-modal--text',
  PROFESSIONAL_REDIRECT_MODAL_TITLE = 'professional-redirect-modal--title',
  PROFESSIONAL_SERVICE_LOCATIONS_IN_PERSON_SECTION = 'professional-service-locations--in-person-section',
  PROFESSIONAL_SERVICE_LOCATIONS_TELEHEALTH_SECTION = 'professional-service-locations--telehealth-section',
  PROFESSIONALS_CLOSE_MODAL_PROFESSIONAL_BY_LETTER = 'close-modal--professional-modal-by-letter',
  PROFESSIONALS_INDEX_CLEAR_LETTER_FILTER_BUTTON = 'button-clear-filter--professional-modal-by-letter',
  PROFESSIONALS_INDEX_LETTER_BUTTON = 'button-letter--professional-list',
  PROFESSIONALS_INDEX_LETTER_FILTER_BUTTON = 'filter-letter--professional-list',
  PROFESSIONALS_INDEX_LINK_BY_PROFESSIONAL_NAME = 'link-by-professional-name--professional-list',
  PROFESSIONALS_INDEX_SEE_MORE_BY_LETTER = 'see-more-by-letter--professional-list',
  SEO_CTA_ASSISTED_PURCHASE_BUTTON = 'seo-index-cta--assisted-purchase-button',
  SEO_CTA_MULTIPLE_BRANCHES_MODAL_COPY_PHONE_BUTTON = 'seo-cta--multiple-branches-modal-copy-phone-button',
  SEO_CTA_MULTIPLE_BRANCHES_MODAL_PHONE_BUTTON = 'seo-cta--multiple-branches-modal-phone-button',
  SEO_CTA_MULTIPLE_BRANCHES_MODAL_WHATSAPP_BUTTON = 'seo-cta--multiple-branches-modal-whatsapp-button',
  SEO_CTA_SCHEDULE_BY_WEB_BUTTON = 'seo-index-cta--schedule-by-web-button',
  SEO_CTA_SCHEDULE_MULTIPLE_BRANCHES_BUTTON = 'seo-index-cta--schedule-multiple-branches-button',
  SEO_CTA_SCHEDULE_MULTIPLE_BRANCHES_MODAL = 'seo-cta--schedule-multiple-branches-modal',
  SEO_CTA_SCHEDULE_NO_BRANCH_BUTTON = 'seo-index-cta--schedule-no-branches-button',
  SEO_CTA_SCHEDULE_NO_BRANCH_MODAL = 'seo-cta--schedule-no-branch-modal',
  SEO_CTA_SCHEDULE_SINGLE_BRANCH_BUTTON = 'seo-index-cta--schedule-single-branches-button',
  SEO_CTA_TELEMEDICINE_BUTTON = 'seo-index-cta--telemedicine-button',
  SHARED_ENTITY_CARD = 'share-button-card--share-button',
  SHARED_ENTITY_CARD_TITLE = 'share-button-modal-title--share-button',
  SHARED_ENTITY_LARGE_TEXT_CARD = 'share-button-large-text-card--share-button',
}
